import { render, staticRenderFns } from "./AccountDeletionAgreement.vue?vue&type=template&id=659e3962&scoped=true&"
import script from "./AccountDeletionAgreement.vue?vue&type=script&lang=js&"
export * from "./AccountDeletionAgreement.vue?vue&type=script&lang=js&"
import style0 from "./AccountDeletionAgreement.vue?vue&type=style&index=0&id=659e3962&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659e3962",
  null
  
)

export default component.exports